//@ts-strict-ignore
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

const flexBox = (props) => {
  return css`
    box-sizing: border-box;
    flex: 0 1 auto;
    flex-direction: row;
    flex-wrap: wrap;
    margin-left: ${(props) => props.theme.grid.negGutterWidth};
    //margin-right: ${(props) => props.theme.grid.negGutterWidth};- causes elements to not respect width
  `;
};

const hideField = ({ flexBox, hideField }) => {
  let displayValue = flexBox ? 'flex' : 'block';
  if (hideField) displayValue = 'none';
  return `
    display: ${displayValue};
  `;
};

const InputBlock: any = styled.div`
  margin-bottom: 0;
  position: relative;
  min-height: 34px;
  align-items: center;
  ${hideField} ${(props) => (props.flexBox ? flexBox(props) : null)};
`;

InputBlock.propTypes = {
  children: PropTypes.array.isRequired,
  flexBox: PropTypes.bool,
};
InputBlock.defaultProps = {
  flexBox: true,
  hideField: false,
};

export default InputBlock;
